/* eslint-disable no-console */
import moengage from '@moengage/web-sdk'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('template', ['credentials']),
    organization() {
      if (this.credentials.length)
        return {
          id: this.credentials[0].company_id ?? '000000',
          name: this.credentials[0].name ?? 'No company name provided',
        }
      else
        return {
          id: 'No company provided',
          name: 'No company name provided',
        }
    },
  },
  methods: {
    storeMoengageMetric(name, additionalData, product = 'chat') {
      try {
        moengage.track_event(`${name}`, additionalData)
      } catch (err) {
        console.error(err)
      }
    },
    getOrganizationForMoengageMetric() {
      return {
        'Company ID': this.organization.id,
        'Company Name': this.organization.name,
      }
    },
  },
}
